export default __webpack_public_path__ + "static/media/foodz@3x.1ae7c631.png";